<template>
  <div>
    <div id="modaldatostransportista" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="
              bg-gray-100
              mx-9
              mb-1
              text-2xl
              shadow-xl
              text-black text-center
              mt-1
              rounded
              divide-y divide-red-500
            "
          >
            Transportistas
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="">
          <div class="col-span-2 justify-center mt-2">
            <div class="px-10 mx-5">
              <div v-if="despachados" class="col-span-1 mx-1 mt-5">
                <label
                  class="
                    block
                    uppercase
                    tracking-wide
                    text-grey-darker text-xs text-center
                    font-bold
                  "
                  for="grid-state"
                >
                  Transportista:
                </label>
                <p class="font-bold">{{ transporte }}</p>
                <hr />
              </div>

              <div v-if="!despachados" class="col-span-1 mx-1 mt-5">
                <label
                  class="
                    block
                    uppercase
                    tracking-wide
                    text-grey-darker text-xs
                    font-bold
                  "
                  for="grid-state"
                >
                  Transportista:
                </label>
                <div class="shadow mt-2 rounded border-black w-72 flex">
                  <select
                    v-model="idtransportista"
                    class="
                      shadow
                      mt-2
                      roundedw-52
                      h-8
                      border-b-2 border-black
                      w-72
                      flex
                      uppercase
                    "
                    id="grid-state"
                  >
                    <option
                      class="uppercase"
                      v-bind:value="tipos.idtransportista"
                      :key="tipos.idtransportista"
                      v-for="tipos of transportistas"
                    >
                      <button>
                        {{ tipos.nombretransportista }}
                      </button>
                    </option>
                  </select>
                </div>
              </div>

              <p class="uppercase text-center divide-y text-sm mt-2">
                numero de guia
              </p>
              <p
                class="divide divide-y text-black mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor">{{ descripcionmodal }} </strong>
              </p>

              <input
                :disabled="despachados"
                v-model="guiaa"
                v-if="despachados"
                class="
                  appearance-none
                  w-full
                  mx-2
                  w-80
                  border-b-2 border-black
                  shadow-xl
                  block
                  col-span-3
                  bg-gray-lighter
                  text-grey-darker
                  rounded
                  py-1
                "
                type="text"
              />
              <input
                v-model="guia"
                v-if="!despachados"
                class="
                  appearance-none
                  w-full
                  mx-2
                  w-80
                  border-b-2 border-black
                  shadow-xl
                  block
                  col-span-3
                  bg-gray-lighter
                  text-grey-darker
                  rounded
                  py-1
                "
                type="text"
              />
            </div>
          </div>

          <div class="inline flex justify-center">
            <div class="col-span-1 mx-2">
              <button
                v-if="!despachados"
                @click="data(), clean()"
                type="button"
                class="
                  w-full
                  inline-flex
                  justify-center
                  mt-5
                  rounded-md
                  border border-transparent
                  shadow-sm
                  px-2
                  py-1
                  bg-blue-600
                  text-base
                  font-medium
                  text-white
                  hover:bg-blue-400
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                  sm:ml-3
                  sm:w-auto
                  sm:text-sm
                "
              >
                <a href="#"> Guardar </a>
              </button>
              <button class="bg-blue400"></button>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modaldatostransportistas",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      valor: false,
      idtransportista: [],
      guia: [],
    };
  },

  methods: {
    ...mapMutations("pedidos", [
      "agregartable",
      "cargardatospendientes",
      "cargardatostransportistasreal",
    ]),

    data() {
      var data = {
        data1: this.idtransportista,
        data2: this.guia,
      };
      this.cargardatostransportistasreal(data);
      setTimeout(() => {
        this.cargardatospendientes();
        setTimeout(() => {
          if (this.len2) {
            this.$notify({
              group: "foo",
              title: "MENSAJE IMPORTANTE",
              text: "SIN PEDIDOS Pendientes!",
              type: "warn",
            });
            this.$notify({
              group: "foo",
              title: "MENSAJE IMPORTANTE",
              text: "Agregado Correctamente!",
             });
          }
        }, 50);
      }, 80);
    },

    mostrarinicial() {
      this.descripcion = this.descripcionmodal;
      this.valor = true;
    },

    clean() {
      this.idtransportista = null;
      this.guia = null;
      this.valor = false;
    },
  },
  computed: {
    ...mapState("pedidos", [
      "idmodal",
      "descripcionmodal",
      "despachados",
      "transporte",
      "transportistas",
      "len2",
      "guiaa",
    ]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 400px;
  height: 280px;

  margin: auto;
  margin-top: 200px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modaldatostransportista:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

